module.exports = __webpack_public_path__ + "static/media/img_panel_1031.16f58e6d.jpg";